import { notifications } from '@mantine/notifications';
import {
  getTourCategoriesKey,
  getTourCategoryKey,
  useGetTourCategory,
  useUpdateTourCategory,
} from 'api-hooks/tour-category';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import TourCategoryForm from './components/form';

export default function TourCategoryView() {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetTourCategory({ id }, { enabled: !!id });
  const updateMutation = useUpdateTourCategory();

  return (
    <TourCategoryForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          id,
        });
        queryClient.refetchQueries(getTourCategoriesKey());
        queryClient.refetchQueries(getTourCategoryKey({ id }));
        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
